import React from "react";
import { useTranslation } from "react-i18next";

import { useMe } from "../../../hooks/queries";
import { AccountType } from "../../../models/AccountData";
import { LocationData } from "../../../models/LocationData";
import { OrganizationData } from "../../../models/OrganizationData";
import LabelsList from "../../FacilityListComponents/LabelsList";
import { CategoriesDisplay } from "../CategoriesDisplay";
import { EditProfileButton } from "../EditProfileButton";
import { EditProfileFormSectionKeys } from "../EditProfileForm/const";
import { QRCodeDisplay } from "../QRCodeDisplay";

import "./styles.scss";

export interface IBasicProfileProps {
  organizationId: string;
  locationData: LocationData;
  onClickReviewCounts?: () => void;
  onOpenModalEditProfile: (
    accordionEventKey?: EditProfileFormSectionKeys | null | undefined
  ) => void;
}

export const BasicProfile: React.FunctionComponent<IBasicProfileProps> = (
  props
) => {
  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`facilityDetailsPage.basicProfile.${key}`);

  const {
    organizationId,
    locationData,
    onClickReviewCounts,
    onOpenModalEditProfile,
  } = props;

  const { data: me } = useMe();

  const isOrgUser = () => {
    return me?.type !== AccountType.LOC_ADMIN;
  };

  return (
    <div className="white-border-panel basic-profile padding32">
      <div className="basic-profile-content">
        <div className="data-group">
          <div className="data-title">{t("municipality")}</div>
          <div className="data-row">
            <div className="values">{locationData.prefecture}</div>
            <div className="values">{locationData.city}</div>
          </div>
        </div>
        <div className="data-group">
          <div className="data-title">{t("category")}</div>
          <div className="data-row">
            <div className="values">
              <CategoriesDisplay locationData={locationData} />
            </div>
          </div>
        </div>
        <div className="data-group">
          <div className="data-title">{t("organizations")}</div>
          <div className="data-row">
            {locationData.organizations?.map(
              (
                itemOrganization: OrganizationData,
                indexOrganization: number
              ) => (
                <div className="values" key={indexOrganization}>
                  {itemOrganization.name}
                </div>
              )
            )}
          </div>
        </div>

        {isOrgUser() && (
          <div className="data-group">
            <div className="data-title">{t("labels")}</div>
            <div className="data-row">
              <LabelsList
                locationId={locationData.id}
                organizationId={organizationId}
              />
            </div>
          </div>
        )}

        <div className="data-group">
          <div className="data-title">{t("rating")}</div>
          <div className="data-row">
            {locationData?.total_review_count ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "baseline",
                }}
              >
                <div className="values">
                  {locationData?.average_rating || "-"}
                </div>
                ⭐
                <div className="sub-values" onClick={onClickReviewCounts}>
                  {`(${locationData?.total_review_count || "0"})`}
                </div>
              </div>
            ) : (
              <div className="values">{t("no_reviews")}</div>
            )}
          </div>
        </div>
        <QRCodeDisplay
          content={`https://search.google.com/local/writereview?placeid=${locationData.gbp_place_id}`}
          downloadFileName={`${locationData.name}__GBP新規口コミ投稿URL_QR-CODE`}
        />
      </div>
      <EditProfileButton
        locationData={locationData}
        onOpenModal={onOpenModalEditProfile}
        accordionEventKey={null}
      />
    </div>
  );
};

export default BasicProfile;
